<div id="valid-values-configuration-container" class="ui-dark-background" data-cy="valid-values-container">
  <mat-progress-spinner style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)" diameter="100" mode="indeterminate" *ngIf="!validValuesList" data-cy="valid-values-loading-spinner"></mat-progress-spinner>
  <mat-grid-list *ngIf="validValuesList" cols="8" rowHeight="100%" style="height:100%;" data-cy="valid-values-grid">
    <mat-grid-tile colspan="2" data-cy="valid-values-list-tile">
      <mat-card appearance="outlined" style="width: 100%; height: 100%; display: flex; flex-direction: column;" data-cy="valid-values-list-card">
        <span class="configuration-section-title" data-cy="valid-values-list-title">Valid Value</span>
        <app-tdo-configuration-action-bar style="flex-basis: fit-content;" saveHidden="true" (newClick)="onNewValidValue()" data-cy="valid-values-list-action-bar"></app-tdo-configuration-action-bar>
        <div style="flex: 1; min-height: 0;" data-cy="valid-values-list-table-container">
          <tdo-table #vvTable sortActive="ValidValueName" sortDirection="asc" [pageSizeOptions]="[25, 50, 75, 100]"
                     [isUsePaginator]="true"
                     [dataSource]="validValuesList" [isSearchable]="true" (rowSelected)="onRowSelected($event)" data-cy="valid-values-list-table">
            <tdo-table-column displayName="Valid Value" propertyName="ValidValueName" [rowTemplate]="name" [isSortable]="true" data-cy="valid-values-name-column">
              <ng-template #name let-row>
                <div style="display: flex; width: 100%;" data-cy="valid-values-name-row-{{row.index}}">
                  <input [value]="row.model.ValidValueName" (appInputFinished)="selectedValidValue.ValidValueName = $event; this.saveValidValue();" style="border: unset; border-bottom: 1px solid #f1f1f1; flex: 1; background-color: unset;" data-cy="valid-values-name-input-{{row.index}}"/>
                  <div style="cursor: pointer; color: var(--tdo-secondary);" (click)="onDeleteValidValue(row.model)" data-cy="valid-values-delete-button-{{row.index}}"><mat-icon>delete</mat-icon></div>
                </div>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div> 
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="6" data-cy="valid-values-detail-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" *ngIf="selectedValidValue" data-cy="valid-values-detail-card">
        <span class="configuration-section-title" data-cy="valid-values-detail-title">Valid Value Editor</span>
        
        <app-tdo-configuration-action-bar  [saveHidden]="isSaveHidden"
                                           [showEdit]="isShowEdit"
                                           [showAdd]="isShowNew"
                                           [showCancel]="isShowCancel"
        (newClick)="onNewValidValueItem()" data-cy="valid-values-detail-action-bar"></app-tdo-configuration-action-bar>

<div data-cy="valid-values-editor-header">
Valid Value Name:
<input [value]="selectedValidValue.ValidValueName" style="width: 300px;"  (appInputFinished)="selectedValidValue.ValidValueName = $event; this.saveValidValue();" data-cy="valid-values-name-input"/>
System List:
<mat-checkbox class="example-margin" [checked]="selectedValidValue.isSystem" (change)="this.changeValidValueisSystem($event);" data-cy="valid-values-system-checkbox">
</mat-checkbox>
</div>


        <tdo-table (rowSelected)="onItemRowSelected($event)" #itemTable *ngIf="selectedValidValue"
                   [dataSource]="selectedValidValue.enumValidValueItems" [isDragAndDrop]="true" (rowsReordered)="onItemsReordered($event);" data-cy="valid-values-items-table">
          <tdo-table-column displayName="Item Name" propertyName="ItemName" [rowTemplate]="name" data-cy="valid-values-item-name-column">
            <ng-template #name let-row>
              <!-- <div style="width: 400px;"> -->
              <input [value]="row.model.ItemName" (appInputFinished)="selectedValidValueItem.ItemName = $event; this.saveValidValueItem(selectedValidValueItem);" style='width:360px' data-cy="valid-values-item-name-input-{{row.index}}" />
              <!-- <input [value]="row.model.ItemName" (appInputFinished)="selectedValidValueItem.ItemName = $event; this.saveValidValueItem(selectedValidValueItem);" 
                   style="border: unset; border-bottom: 1px solid #f1f1f1; width: 100%; background-color: unset;"/> -->

              <!-- </div> -->
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Display Value" propertyName="ItemDisplayValue" [rowTemplate]="displayValue" data-cy="valid-values-item-display-column">
            <ng-template #displayValue let-row>
              <input [value]="row.model.ItemDisplayValue" (appInputFinished)="selectedValidValueItem.ItemDisplayValue = $event; this.saveValidValueItem(selectedValidValueItem);" style='width:200px' data-cy="valid-values-item-display-input-{{row.index}}" />
              <!-- style="border: unset; border-bottom: 1px solid #f1f1f1; width: 100%; background-color: unset;" -->
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Short Value" propertyName="ItemSValue" [rowTemplate]="shortValue" data-cy="valid-values-item-short-column">
            <ng-template #shortValue let-row>
              <input [value]="row.model.ItemSValue" (appInputFinished)="selectedValidValueItem.ItemSValue = $event; this.saveValidValueItem(selectedValidValueItem);" style='width:100px' data-cy="valid-values-item-short-input-{{row.index}}"/>
              <!-- style="border: unset; border-bottom: 1px solid #f1f1f1; width: 100%; background-color: unset;" -->
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="System" propertyName="isSystem" [rowTemplate]="system" [isSortable]="true" data-cy="valid-values-item-system-column">
            <ng-template #system let-row>
              <mat-checkbox (change)="onSystemChange($event, row.model)" style="position: relative; top: 5px;" class="example-margin"
                            [checked]="row.isSystem" data-cy="valid-values-item-system-checkbox-{{row.index}}">
              </mat-checkbox>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Color" propertyName="ColorSchemeId" [rowTemplate]="color" data-cy="valid-values-item-color-column">
            <ng-template #color let-row>
              <app-tdo-color-scheme-picker (schemeChange)="onSchemeChange($event)" [selectedColorSchemeId]="row.model.ColorSchemeId" [dataSource]="colorSchemes" data-cy="valid-values-item-color-picker-{{row.index}}"></app-tdo-color-scheme-picker>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Icon" propertyName="IconIDSVG" [rowTemplate]="image" data-cy="valid-values-item-icon-column">
            <ng-template #image let-row>
              <!-- <img [src]="row.model.IconIDSVG"/> -->
              
              <app-tdo-image-picker (imageChange)="onImageChange($event)" [showLabel]="false" [dataSource]="imageDataSource" [selectedImage]="row.model.IconIDSVG" style="position: relative; top: 3px;" data-cy="valid-values-item-icon-picker-{{row.index}}"></app-tdo-image-picker>
            </ng-template>

          </tdo-table-column>
          <tdo-table-column displayName="" propertyName="xauditDeleted" [rowTemplate]="delete1" data-cy="valid-values-item-delete-column">
            <ng-template #delete1 let-row>
              <div (click)="onDeleteItem(row.model)" style="cursor: pointer; color: var(--tdo-secondary); margin-top: 6px;" [matTooltip]="'Delete ' + row.model.ItemName" data-cy="valid-values-item-delete-button-{{row.index}}"><mat-icon>delete</mat-icon></div>
            </ng-template>
          </tdo-table-column>
        </tdo-table>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>



<dx-tree-view data-cy="valid-values-tree-view"></dx-tree-view>


